module.exports = __webpack_public_path__ + "img/blue_027.34a89050.png";